<template>
  <div id="responsibility">
    <navigation-sub
      :list="[
        {
          title: $t('menuSustainability.ethicalManagement'),
          anchor: $t('conduct.title')
        },
        {
          title: $t('menuSustainability.compliance'),
          anchor: $t('compliance.declaration.title')
        },
        {
          title: $t('menuSustainability.sustainable'),
          anchor: $t('sustainable.declaration.title')
        },
        {
          title: $t('menuSustainability.informationProtection'),
          anchor: $t('informationProtection.compliance.title')
        }
      ]"
    />

    <Ethical />
    <Compliance />
    <Sustainable />
    <InformationProtection />
  </div>
</template>
<script>
import InformationProtection from '@/views/sustainability/responsibility/InformationProtection.vue'
import Ethical from '@/views/sustainability/responsibility/Ethical.vue'
import Sustainable from '@/views/sustainability/responsibility/Sustainable.vue'
import Compliance from '@/views/sustainability/responsibility/Compliance.vue'
import gtag from '@/mixins/gtag'

export default {
  components: {
    navigationSub: () => import('@/components/base/NavigationSub'),
    Compliance,
    Sustainable,
    Ethical,
    InformationProtection
  },
  mixins: [gtag],
}
</script>
